/** rum */
import '@yandex-int/rum-counter/dist/inline/interface'
import '@yandex-int/rum-counter/dist/inline/longtask'
import '@yandex-int/rum-counter/dist/bundle/send'
import './internal/sensitiveDataCleaner'
import './internal/debugger'
import './internal/initRum'
import '@yandex-int/rum-counter/dist/bundle/implementation'
import '@yandex-int/rum-counter/dist/bundle/onload'

/** errors */
import '@yandex-int/error-counter/dist/interfaceOverRum'
import '@yandex-int/error-counter/dist/implementation'
import '@yandex-int/error-counter/dist/filters'
import '@yandex-int/error-counter/dist/logError'
import '@yandex-int/error-counter/dist/logEvent'
import '@yandex-int/error-counter/dist/traceUnhandledRejection'
import './internal/initErrors'

// send initial events
import './internal/watchPageLifecycle'
import './internal/watchPathNameChange'
import './internal/sendInfoEvents'

console.debug(`[rum] [${new Date().toISOString()}]:`, 'init_end')
